import { FunctionComponent } from 'react';
import { ServerError } from '@global/screens/ServerError';
import { useUserContext } from '@context/UserProvider';

export const AuthGuard = (component: FunctionComponent<any>) =>
    useUserContext().user.isAuthenticated ? component : ServerError;
